module.exports = __webpack_public_path__ + "img/lightbulb-exclamation-on.c9d3b65e.svg";